import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DrawerAppBar from './components/DrawerAppBar';
import Hjem from './components/Home';
import AboutUs from './components/OmOss';
import Activities from './components/Activities';
import Contact from './components/Contact';
import Language from './components/Language';
import Signup from './components/Signup';
import SignInOutContainer from './containers/SignInOutContainer';
import { Modal } from '@mui/material';
import EventsContext from "./components/EventsContext";
import Calendar from './components/Calendar';
import Admin from './containers/Admin';
import Footer from './components/Footer';
import { Box } from '@mui/material';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
/>


const App = () => {
  const [open, setOpen] = useState(false);
  const [filteredEvents, setFilteredEvents] = React.useState([]);


  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Router>
        <DrawerAppBar handleOpen={handleOpen} />
        <Modal open={open} onClose={handleClose}>
          <SignInOutContainer handleClose={handleClose} />
        </Modal>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Box sx={{ flex: '1' }}>
          <EventsContext.Provider value={{ filteredEvents, setFilteredEvents }}>
            <Routes>
              <Route path="/" Component={Hjem} exact />
              <Route path="/about-us" Component={AboutUs} />
              <Route path="/activities" Component={Activities} />
              <Route path="/contact" Component={Contact} />
              <Route path="/language" Component={Language} />
              <Route path="/signup" Component={Signup} />
              <Route path="/calendar" Component={Calendar} />
              <Route path="/admin" Component={Admin} />
            </Routes>
            </EventsContext.Provider>
          </Box>
          <Footer />
        </Box>
      </Router>
    </>
  );
};

export default App;
